import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      // Always shows the same generic confirmation, regardless of the response —
      // never hint client-side whether the account exists.
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1e3a5f 0%,#2563eb 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔑</div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1e3a5f' }}>Forgot password?</h1>
          <p style={{ color: '#64748b', fontSize: '0.85rem', marginTop: '0.25rem' }}>
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        {error && <div className="error-box">{error}</div>}

        {sent ? (
          <p style={{ textAlign: 'center', color: '#374151', fontSize: '0.9rem', lineHeight: 1.6 }}>
            If an account exists for that email, a reset link has been sent. Please check your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'grid', gap: '0.3rem', marginBottom: '1.5rem', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
              Email address
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required autoFocus />
            </label>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '0.75rem' }} disabled={loading}>
              {loading ? <span className="spinner" style={{ width: 16, height: 16 }} /> : 'Send reset link →'}
            </button>
          </form>
        )}

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.85rem', color: '#64748b' }}>
          <Link to="/login" style={{ color: '#2563eb', fontWeight: 600 }}>← Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
